<div *ngIf="type">
	<i nz-icon nzType="icons:facility-types/{{ type }}"></i>
	<span>{{ getFacilityTypeName() }}</span>
</div>
